
import { defineComponent, PropType } from 'vue';
import BaseTable from '@/components/BaseTable.vue';
import { Currency } from '@/types/models';

export default defineComponent({
  components: {
    BaseTable,
  },
  columns: {
    name: {
      name: 'Name',
      align: 'left',
    },
    price: {
      name: 'Price',
      align: 'right',
    },
    marketCap: {
      name: 'Market Cap',
      align: 'right',
    },
    change24h: {
      name: 'Change (24h)',
      align: 'right',
    },
    volume24h: {
      name: 'Volume (24h)',
      align: 'right',
    },
  },
  props: {
    currencies: {
      type: Array as PropType<Currency[]>,
      default: () => null,
    },
  },
});
